import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { css } from '@emotion/core';
import { Select } from 'antd';
import { injectIntl } from 'react-intl';
import Dropdown from '../../../components/common/Dropdown';
import Button from '../../../components/common/Button';
import {
  ButtonGroup,
  CardWrapper,
  CardHeader,
  FormGroup,
  Container,
  subLabel,
  subRow,
  Input,
  Index,
  Card,
  Row,
} from './styled';

const TYPES = {
  ACCOUNTS: 'accounts',
  TRIPLE_MARS: 'triplemars',
};

const { Option } = Select;

@injectIntl
@inject('settingsStore')
@observer
class SourceConnect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedType: '',
    };
    this.handleTypeClick = this.handleTypeClick.bind(this);
    this.handleSubmitForm = this.handleSubmitForm.bind(this);
  }
  componentDidMount() {
    const { formatMessage } = this.props.intl;
    const breadcrumb = { name: formatMessage({ id: 'settingsModal.connectSource' }) };
    this.props.updateBreadcrumbs(breadcrumb, false);
  }

  componentWillUnmount() {
    const {
      connectSource: { resetFields },
    } = this.props.settingsStore.connectionManagement;
    resetFields();
  }

  handleTypeClick(type) {
    this.setState({ selectedType: type });
  }

  handleSubmitForm(e) {
    e.preventDefault();
    const {
      settingsStore:{connectionManagement:{connectSource:{connectSourceAccountAndUpdateList}}},
      closeForm
    } = this.props;
    connectSourceAccountAndUpdateList();
    closeForm();
  }

  render() {
    const { selectedType } = this.state;
    const {
      sources,
      password,
      username,
      setUsername,
      setPassword,
      setSource,
      resetFields,
      sourceMarketplace,
      selectedSourceName,
    } = this.props.settingsStore.connectionManagement.connectSource;

    const disabled = !sourceMarketplace || !password || !username;
    return (
      <Container>
        <FormGroup>
          <Row>
            <label>
              <Index>1.</Index>
              <span> Select Connection Type</span>
            </label>
          </Row>
          <CardWrapper>
            <Card
              onClick={() => this.handleTypeClick(TYPES.ACCOUNTS)}
              selected={selectedType === TYPES.ACCOUNTS}
              tabIndex="0"
            >
              <CardHeader>Connect My Accounts</CardHeader>
              <span>Connect your existing source accounts</span>
            </Card>
            <Card tabIndex="0" disabled>
              <CardHeader value="triplemars">Buy Through TripleMars</CardHeader>
              <span>Save your time and purchase throught TripleMars for best prices</span>
            </Card>
          </CardWrapper>
        </FormGroup>
        {selectedType === TYPES.ACCOUNTS ? (
          <form onSubmit={this.handleSubmitForm}>
            <FormGroup>
              <Row>
                <label htmlFor="source">
                  <Index>2.</Index>
                  <span> Select Source</span>
                </label>
                <Dropdown value={selectedSourceName} id="source" onSelect={setSource}>
                  {sources.map(({ id, name }) => (
                    <Option value={id} key={id}>
                      {name}
                    </Option>
                  ))}
                </Dropdown>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row css={subRow}>
                <label htmlFor="source-name">
                  <Index>3.</Index>
                  <span> Email</span>
                </label>
                <Input value={username} name="source-name" type="text" onChange={setUsername} />
              </Row>
              <Row>
                <label htmlFor="source-password" css={subLabel}>
                  Password
                </label>
                <Input
                  type="password"
                  name="source-password"
                  value={password}
                  onChange={setPassword}
                />
              </Row>
            </FormGroup>
            <ButtonGroup>
              <Button
                css={css`
                  margin-right: 8px;
                `}
                htmlType="submit"
                disabled={disabled}
                height="22px"
              >
                Connect
              </Button>
              <Button type="secondary" htmlType="reset" clickHandler={resetFields} height="22px">
                Cancel
              </Button>
            </ButtonGroup>
          </form>
        ) : null}
      </Container>
    );
  }
}

SourceConnect.propTypes = {
  updateBreadcrumbs: PropTypes.func.isRequired,
  intl: PropTypes.object,
  settingsStore: PropTypes.object,
  closeForm: PropTypes.func,
};

export default SourceConnect;
